import { cn } from "@/lib/utils";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
  as?: "h1" | "h2";
}

export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  centered = true,
  className,
  as: Heading = "h2",
}: SectionHeadingProps) {
  return (
    <div className={cn(centered && "text-center", className)}>
      {eyebrow && (
        <p className="text-terracotta font-medium tracking-wide uppercase text-sm mb-3">
          {eyebrow}
        </p>
      )}
      <Heading className="font-serif text-3xl md:text-4xl lg:text-5xl text-warm-gray-dark">
        {title}
      </Heading>
      <div
        className={cn(
          "w-16 h-0.5 bg-terracotta mt-4",
          centered && "mx-auto"
        )}
      />
      {subtitle && (
        <p className="text-warm-gray-light text-lg mt-4">{subtitle}</p>
      )}
    </div>
  );
}
